import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class NewReviTherapyApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
  }

  // --- LECTURA ---

  /**
   * Listar "Mis Terapias"
   * Endpoint esperado: /revi/therapy/therapist/:id
   */
  async getMyTherapies(
    token,
    therapistId,
    { page = 1, limit = 10, search = "" } = {},
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) params.append("search", search);

    // FIX: Ruta explícita
    const url = `${this.baseApi}/revi/therapy/therapist/${therapistId}?${params.toString()}`;

    console.log("📡 Fetching Therapies from:", url); // DEBUG LOG

    const res = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    return {
      therapies: json.therapies,
      pagination: json.pagination,
    };
  }

  /**
   * Marketplace
   */
  async getSharedTherapies(
    token,
    { page = 1, limit = 12, categoryId = null } = {},
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (categoryId) params.append("categoryId", categoryId);

    const url = `${this.baseApi}/revi/therapy/shared/all?${params.toString()}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    return {
      therapies: json.therapies,
      pagination: json.pagination,
    };
  }

  // --- MUTACIONES (CUD) ---

  /**
   * Crear nueva terapia
   * Endpoint esperado: POST /revi/therapy
   */
  async createTherapy(token, data) {
    // FIX CRÍTICO: Escribimos la cadena literal "therapy" para evitar errores de constantes
    // Antes apuntaba a therapy-category por error de configuración
    const url = `${this.baseApi}/revi/therapy`;

    console.log("🚀 Creating Therapy at:", url); // DEBUG LOG
    console.log("📦 Payload:", data); // DEBUG LOG

    const res = await fetch(url, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const json = await res.json();

    // Si falla, lanzamos el error con detalles
    if (res.status !== 201) {
      console.error("❌ Error Backend:", json);
      throw new Error(json.message || "Error al crear terapia");
    }

    return json.therapy;
  }

  async updateTherapy(token, id, data) {
    const url = `${this.baseApi}/revi/therapy/${id}`;
    const res = await fetch(url, {
      method: "PATCH",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return json.therapy;
  }

  async deleteTherapy(token, id) {
    const url = `${this.baseApi}/revi/therapy/${id}`;
    const res = await fetch(url, {
      method: "DELETE",
      headers: cabecerasApi(token),
    });
    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);
    return true;
  }

  async cloneTherapy(token, id) {
    const url = `${this.baseApi}/revi/therapy/${id}/clone`;
    const res = await fetch(url, {
      method: "POST",
      headers: cabecerasApi(token),
    });
    const json = await res.json();
    if (res.status !== 201) throw new Error(json.message);
    return json.therapy;
  }

  /**
   * Obtener el detalle completo de una terapia (Hidratada con escenas)
   * GET /revi/therapy/:id
   */
  async getTherapyById(token, therapyId) {
    const url = `${this.baseApi}/revi/therapy/${therapyId}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    // Devuelve el objeto { code, message, therapy: {...} }
    return json.therapy;
  }

  /**
   * Eliminar un paso (escena) de la terapia
   * DELETE /revi/therapy/:id/scene/:stepId
   */
  async removeSceneStep(token, therapyId, stepId) {
    const url = `${this.baseApi}/revi/therapy/${therapyId}/scene/${stepId}`;

    const res = await fetch(url, {
      method: "DELETE",
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    return true;
  }

  /**
   * Añadir una escena (step) a una terapia
   * POST /revi/therapy/:id/scene
   */
  async addSceneStep(token, therapyId, data) {
    const url = `${this.baseApi}/revi/therapy/${therapyId}/scene`;

    const res = await fetch(url, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const json = await res.json();

    // Backend devuelve 200 en éxito según controller
    if (res.status !== 200) {
      console.error("❌ Error Backend:", json);
      throw new Error(
        json?.message || "No se pudo añadir la escena a la terapia",
      );
    }

    return json?.therapy || json;
  }
}
